import math from "core/math";

import CustomEvent from "core/customEvent/index";

class BrowseSeriesTool {
  constructor() {
    this.orientation = 0;
  }

  onMouseDrag = event => {
    const eventData = event.detail;
    const element = event.detail.element.element;
    const [startX, startY, imageX, imageY] = [
      event.detail.startPoints.page.x,
      event.detail.startPoints.page.y,
      event.detail.startPoints.image.x,
      event.detail.startPoints.image.y
    ];

    const newCoords = math.coordinate.pageToPixel(element, startX, startY);
    let direction = {
      x: imageX - newCoords.x,
      y: imageY - newCoords.y
    };

    const deltaPageY = -parseInt(
      (eventData.currentPoints.page.y - eventData.startPoints.page.y) / 4
    );

    const nextImageIndex = eventData.imageIndex - deltaPageY;
    const currentImageIndex = eventData.viewportObject.getImageIndex();
    const deltaY = currentImageIndex - nextImageIndex;
    const mouseWheelData = {
      element,
      image: event.detail.element.image,
      direction: deltaY,
      pageX: direction.x,
      pageY: direction.y
    };

    CustomEvent.triggerEvent(
      element,
      CustomEvent.EVENTS.MOUSE_WHEEL,
      mouseWheelData
    );
  };
}

// Module exports
export default BrowseSeriesTool;
